import 'css-chunksrc/client/common/filterMenu/zones/zone/projects/project/styles.scss';export default {
  "project": "_project_1of52_1",
  "icon": "_icon_1of52_11",
  "name": "_name_1of52_19"
};